<template>
  <div class="ui-callout" :class="`ui-callout--${variant}`" :data-tone="tone ?? undefined">
    <slot />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: "muted" | "info" | "warning" | "danger" | "success";
    tone?: "travel" | "work" | "combat" | "econ" | "social" | null;
  }>(),
  {
    variant: "info",
    tone: null
  }
);
</script>

<style scoped>
.ui-callout {
  border-radius: var(--radius-2);
  padding: 0.75rem 1rem;
  border: 1px solid transparent;
  font-size: 0.9rem;
}

.ui-callout--muted {
  background: var(--chip-muted-bg);
  border-color: var(--chip-muted-border);
  color: var(--fg-0);
}

.ui-callout--info {
  background: color-mix(in srgb, var(--accent) 10%, transparent);
  border-color: color-mix(in srgb, var(--accent) 38%, transparent);
  color: var(--fg-0);
}

.ui-callout--warning {
  background: color-mix(in srgb, var(--state-warning) 12%, transparent);
  border-color: color-mix(in srgb, var(--state-warning) 45%, transparent);
}

.ui-callout--danger {
  background: color-mix(in srgb, var(--state-danger) 12%, transparent);
  border-color: color-mix(in srgb, var(--state-danger) 45%, transparent);
  color: var(--fg-0);
}

.ui-callout--success {
  background: color-mix(in srgb, var(--state-active) 12%, transparent);
  border-color: color-mix(in srgb, var(--state-active) 45%, transparent);
}

.ui-callout[data-tone="travel"] {
  --accent: var(--accent-travel);
}

.ui-callout[data-tone="work"] {
  --accent: var(--accent-work);
}

.ui-callout[data-tone="combat"] {
  --accent: var(--accent-combat);
}

.ui-callout[data-tone="econ"] {
  --accent: var(--accent-econ);
}

.ui-callout[data-tone="social"] {
  --accent: var(--accent-social);
}
</style>
